import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import api from '../config/axiosConfig';
import { asArray, readPayload } from '../utils/dataUtils';
import { assertApiSuccess, getErrorMessage } from '../utils/apiResponseUtils';

export default function SavedAddresses({ pickupLocation, senderContact, onSelect }) {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const load = useCallback(async () => {
    setLoading(true); setError('');
    try {
      const response = await api.get('/account/addresses');
      assertApiSuccess(response);
      setAddresses(asArray(readPayload(response)));
    }
    catch (err) { setError(getErrorMessage(err, 'Unable to load saved addresses.')); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { setSaved(false); }, [pickupLocation, senderContact]);
  const save = async () => {
    if (saving || !pickupLocation) return;
    setSaving(true); setError(''); setSaved(false);
    try {
      const response = await api.post('/account/addresses', {
        label: 'OTHER', houseDetails: pickupLocation.address || pickupLocation.name,
        location: pickupLocation, contactName: senderContact?.name || '', contactPhone: senderContact?.phone || '',
      });
      assertApiSuccess(response);
      await load(); setSaved(true);
    } catch (err) { setError(getErrorMessage(err, 'Unable to save pickup address.')); }
    finally { setSaving(false); }
  };
  return <section aria-label="Saved addresses" className="mb-3">
    <h3 className="h5">Saved addresses</h3>
    {error && <Alert variant="danger">{error}<Button variant="link" onClick={load} disabled={loading}>Retry addresses</Button></Alert>}
    {loading ? <p role="status">Loading saved addresses...</p> : addresses.length ? <ul className="list-unstyled">
      {addresses.map((item, index) => <li className="border-bottom py-2" key={item.id || index}>
        <strong>{item.label || item.location?.name || 'Address'}</strong>
        <p className="mb-1">{item.houseDetails || item.location?.address || item.address}</p>
        <p className="mb-1">{item.contactName} {item.contactPhone}</p>
        {onSelect && item.location && <Button size="sm" variant="outline-primary" onClick={() => onSelect(item)}>Use for pickup</Button>}
      </li>)}
    </ul> : <p>No saved addresses yet.</p>}
    {onSelect && <><Form.Text className="d-block">Save the selected pickup location and sender contact to your account.</Form.Text><Button variant="outline-primary" disabled={!pickupLocation || saving || saved} onClick={save}>{saving ? 'Saving address...' : saved ? 'Address saved' : 'Save pickup address'}</Button></>}
  </section>;
}
